import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import {privateCoreLogin} from "../../../redux/actions";
import { connect } from "react-redux";
import Alert from "react-bootstrap/es/Alert";
import {withRouter} from "react-router-dom";
import FieldGroup from "../../FieldGroup";

class PrivateCoreLoginForm extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.id = props.match.params.id;
        this.handleClick = this.handleClick.bind(this);
        this.usernameChanged = this.usernameChanged.bind(this);
        this.passwordChanged = this.passwordChanged.bind(this);

        this.state = {
            customer: this.props.customer
        };
    }

    componentDidUpdate() {
        if(this.isLoggingIn && this.props.pendingCalls === 0 && !this.props.error && this.props.privateCoreJwt[this.id]) {
            this.isLoggingIn = false;
            this.props.history.push('/customers/'+this.id+"/private")
        }
    }

    handleClick(e) {
        e.preventDefault();
        this.isLoggingIn = true;
        this.props.dispatch(privateCoreLogin({username: this.state.username, password: this.state.password}));
    }

    usernameChanged(e) {
        this.setState({username: e.target.value});
    }

    passwordChanged(e) {
        this.setState({ password: e.target.value });
    }

    render() {
        return (
            <Row className="show-grid">
                <Col xsHidden={true} smHidden={true} md={2} lg={4} />
                <Col xs={12} sm={12} md={8} lg={4}>
                    {this.state.customer ? <form>
                        <h2>Private core login</h2>
                        <h3>{this.props.customer.configuration.privateCore.httpsEnabled ? "https://" : "http://"}{this.state.customer.configuration.privateCore.dns}:{this.state.customer.configuration.privateCore.httpPort}</h3>
                        <FieldGroup
                            autoComplete="username"
                            id="username"
                            type="text"
                            label="Username"
                            onChange={this.usernameChanged}
                            placeholder="Enter username"
                        />
                        <FieldGroup
                            autoComplete="current-password"
                            id="password"
                            type="password"
                            label="Password"
                            onChange={this.passwordChanged}
                            placeholder="Enter password"
                        />
                        {typeof this.props.error !== 'undefined' ?
                            <Alert bsStyle="danger">
                                {this.props.error}
                            </Alert> : null}
                        <Button block={true} disabled={this.props.pendingCalls > 0} onClick={this.handleClick}
                                bsStyle="primary" type="submit">Login</Button>
                    </form> : null}
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = state => {
    return { customer: state.currentCustomer, pendingCalls: state.pendingCalls, error: state.lastError, privateCoreJwt: state.privateCoreJwt };
};

const mapDispatchToProps = (dispatch) => ({dispatch});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateCoreLoginForm));


// WEBPACK FOOTER //
// ./src/components/customer/private/PrivateCoreLoginForm.js